import {
  ArrowCircleIcon,
  BoxIcon,
  DoneCircleIcon,
  HomeIcon,
  RefundIcon,
  RouteIcon,
  WarehouseIcon,
} from 'src/components';
import { NotificationsMessagesTypes } from 'src/notifications';
import { RComponent } from 'src/types';
import { HistoryPublicModelData } from 'src/types/public/public-data-model.types';

type StatusReturn = {
  icon: RComponent;
  status: string;
  subStatus?: label;
};

type label = {
  label: string;
  translatingOptions?: Record<string, unknown> | undefined;
};

export const getHistoryColiStatusByHistoryItem = (history: HistoryPublicModelData): StatusReturn => {
  let status = '';
  let subStatus: label = {
    label: '',
  };

  let icon: RComponent = BoxIcon;

  switch (history.status) {
    case 'AGENCY': {
      status =
        history.description === NotificationsMessagesTypes.coliCreatedAtAgency
          ? 'tracker-coli-info.colis-created-at-agency'
          : history.status;
      icon = HomeIcon;
      subStatus = { label: history.agency?.name ?? '' };
      break;
    }

    case 'WAREHOUSE': {
      status = history.status;
      icon = WarehouseIcon;
      subStatus = { label: history.warehouse?.name ?? '' };
      break;
    }

    case 'CANCELLED': {
      status = history.status;
      icon = RefundIcon;
      break;
    }
    case 'DELIVREY_SERVICE_ACCEPTED': {
      status = history.status;
      icon = RouteIcon;
      break;
    }
    case 'DELIVREY_SERVICE_DELIVERED_TO_TRANSPORT':
    case 'DELIVREY_SERVICE_ON_ROAD': {
      status = history.status;
      icon = RouteIcon;
      break;
    }
    case 'DELIVERY_SCHEDULING_DELIVERY': {
      status = history.status;
      icon = RouteIcon;
      break;
    }

    case 'DISPATCHED': {
      status = history.status;
      icon = RouteIcon;
      // if (history.voyage) {
      //   subStatus = {
      //     label: 'tracker-coli-info.driver',
      //     translatingOptions: { driver: history.voyage. },
      //   };
      // }
      break;
    }

    case 'DELIVERED':
    case 'DELIVERD_TO_TRANSPORT': {
      status = history.status;
      icon = DoneCircleIcon;
      subStatus = { label: history.agency?.name ?? '' };
      break;
    }

    case 'WITHDRAWN': {
      status = history.status;
      icon = ArrowCircleIcon;
      break;
    }

    case 'LOADED': {
      status = history.status;
      icon = BoxIcon;
      // subStatus = {
      //   label: 'tracker-coli-info.loaded-by-user',
      //   translatingOptions: { user: history.user.firstName },
      // };
      break;
    }
  }

  return {
    status,
    subStatus,
    icon,
  };
};
